import moment from 'moment';
import { parseUnits, submitsToHashrate, formatCoinbasePrice } from '../utils';

export default class MinerJobsCard {
    constructor(divToAppend) {
        this.container = divToAppend;
        divToAppend.innerHTML = `<div class="card"></div>`;
    }

    async render(job, chainStats) {

        if (!job) {
            this.container.innerHTML = `
            <div class="card">
                <div class="empty" style='background-image: url("./10094316_39392.png");background-position: -112px 400px;background-repeat: no-repeat;'>
                    <p class="empty-title">No job has been sent in last 24 hours</p>
                    <p class="empty-subtitle text-secondary">
                        Propably that means that you don't have any miner connected yet.<br/>
                        If you need help with configuring your miner contact us at contact@minemine.online
                    </p>
                </div>
            </div>`;

            return;
        }

        let blockRewardHTML = `<div class="display-5 fw-bold">${ Math.round(job.blockReward/10000) / 10000 } ${ job.coin.toUpperCase() }</div>`;
        if (job.coin == 'xec') blockRewardHTML = `<div class="display-5 fw-bold">${ Math.round(job.blockReward/100) } ${ job.coin.toUpperCase() }</div>`;

        this.container.innerHTML = `
        <div class="card">
            <div class="card-body">
                <h3 class="card-title">
                    <IconCubeSend /> Last block sent to your miner: <span class="ml-1 badge badge-outline text-yellow">${ job.height }</span>
                </h3>

                <div class="subheader">Block reward</div>
                ${blockRewardHTML}
                <div class="h1">~ $${ formatCoinbasePrice(job.coin, job.blockReward, chainStats.price) }</div>

                <div class="datagrid mb-1">
                    <div class="datagrid-item">
                        <div class="datagrid-title">Block height</div>
                        <div class="datagrid-content"><span class="badge badge-outline text-yellow">${ job.height }</span></div>
                    </div>

                    <div class="datagrid-item">
                        <div class="datagrid-title">TXs count</div>
                        <div class="datagrid-content">${ job.txs }</div>
                    </div>

                    <div class="datagrid-item">
                        <div class="datagrid-title">Sent</div>
                        <div class="datagrid-content">${ moment(job.at).from() }</div>
                    </div>

                    <div class="datagrid-item">
                        <div class="datagrid-title">Bits</div>
                        <div class="datagrid-content"><kbd>${ job.bits }</kbd></div>
                    </div>
                </div>

                <div class="subheader my-2">Coinbase transaction</div>
                <pre style="white-space: normal;">${ job.coinbase }</pre>
                <p class="text-secondary">A coinbase transaction is the first transaction in a block. It's placed there by the miner when they construct their candidate block so they can claim the block reward (block subsidy + fees) if they are successful in mining the block.<br/>For more info read <a target="_blank" href="https://learnmeabitcoin.com/technical/mining/coinbase-transaction/">this article</a></p>
                <p class="text-secondary">We display it here so that you can make sure for yourself that <mark>your address is definitely included in the block</mark> being mined. Zero intermediaries - the block reward goes directly into your wallet</p>
            </div>
        </div>`;
    }
}